import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierDocumentStatusController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierDocumentStatusController.php
* @route '/api/dossier/{dossier}/document/{document}/status'
*/
const UpdateDossierDocumentStatusController = (args: { dossier: string | number | { id: string | number }, document: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierDocumentStatusController.url(args, options),
    method: 'put',
})

UpdateDossierDocumentStatusController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/document/{document}/status',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierDocumentStatusController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierDocumentStatusController.php
* @route '/api/dossier/{dossier}/document/{document}/status'
*/
UpdateDossierDocumentStatusController.url = (args: { dossier: string | number | { id: string | number }, document: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, document: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            document: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        document: typeof args.document === 'object'
        ? args.document.id
        : args.document,
    }

    return UpdateDossierDocumentStatusController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierDocumentStatusController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierDocumentStatusController.php
* @route '/api/dossier/{dossier}/document/{document}/status'
*/
UpdateDossierDocumentStatusController.put = (args: { dossier: string | number | { id: string | number }, document: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, document: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierDocumentStatusController.url(args, options),
    method: 'put',
})

export default UpdateDossierDocumentStatusController